module.exports = __webpack_public_path__ + "img/thewildfirecollection.cc46dd84.png";